/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsDeleteMutationResponse, ProjectsDeletePathParams } from "../models/ProjectsDelete";

export function getProjectsDeleteUrl(id: ProjectsDeletePathParams["id"]) {
  const res = { method: 'DELETE', url: `/projects/${id}` as const }  
  return res
}

/**
 * @summary Delete a project
 * {@link /projects/:id}
 */
export async function projectsDelete(id: ProjectsDeletePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectsDeleteMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getProjectsDeleteUrl(id).url.toString(), ... requestConfig })  
  return res.data
}